import React from 'react'
import "./../../UaeAttestation/UaeCertificate/UaeCertificate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
const AustraliaNonEduCert = () => {
  return (
    <div className="uaeEduCertContainer">
    <h2>Non-Educational Certificate Apostille</h2>
    <ul>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Birth Certificate apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Marriage Certificate apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Salary Certificate apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Equivalence Certificate
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Single Status Certificate apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Ministry of education department apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Foreign Affairs (FA) Apostille/Legalization
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Transfer Certificate (TC) Apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Experience/ Employment Certificate Apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Medical Certificate Apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Ministry of health department apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Ministry of Justice apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Chamber of commerce apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Labor department apostille
      </li>
      <li>
        <FontAwesomeIcon
          icon={faAnglesRight}
          className="eduCertIcon"
        ></FontAwesomeIcon>
        Death Certificate Apostille
      </li>
      <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          Registration Certificate Attestation
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          Power of Attorney Certificate Attestation
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          Bona-fide Certificate Attestation
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          Packaging list
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          Power of Attorney
        </li>
  
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          Certificate of Origin
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          Certificate of incorporation
        </li>
        <li>
          <FontAwesomeIcon
            icon={faAnglesRight}
            className="eduCertIcon"
          ></FontAwesomeIcon>
          Export Invoice{" "}
        </li>
    </ul>
  </div>
  )
}

export default AustraliaNonEduCert
